<template>
  <WidgetHelpdesk
    size="big"
    class="mb-20"
    :icon-size="32"
    :icon-wrapper-size="80"
    data-cy="widget_helpdesk"
  >
    <template #title>
      {{ $t('Potrebujete') }}
      <br class="d-none d-lg-block">
      {{ $t('pomôcť?') }}
    </template>
    <template #subtitle>
      {{ $t('Kontakty') }}
    </template>
  </WidgetHelpdesk>
</template>
